const routes = [
    {
        path: "/slots/:id/",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "slot_index"
        }
    }
];

export default routes;
